import { render, staticRenderFns } from "./InventoryReservationCreate.vue?vue&type=template&id=7d66734b"
import script from "./InventoryReservationCreate.vue?vue&type=script&lang=js"
export * from "./InventoryReservationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d66734b')) {
      api.createRecord('7d66734b', component.options)
    } else {
      api.reload('7d66734b', component.options)
    }
    module.hot.accept("./InventoryReservationCreate.vue?vue&type=template&id=7d66734b", function () {
      api.rerender('7d66734b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryReservationCreate.vue"
export default component.exports